import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import IComuna from '../models/comuna.interface';
import { IResponseAPIListado } from '../models/responseAPI.interface';
import { DangerError } from '../shared/errors/custom.error';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class ComunaService {

  constructor(private http: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) { }

  async obtenerComunas(regCodigo: number): Promise<IComuna[]> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const url = environment.backendUrl + `/esi-comunas` + `?region=${regCodigo}`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'session_id': this.sessionService.getToken() || ''
    });

     const { data, msg, success } =
            await firstValueFrom(this.http.post<IResponseAPIListado>(
                url,
                {},
                { headers }
            ));

      if (!success) throw new DangerError(msg);
      
      return data.map((item: any) => ({
            codigo: Number(item.com_codigo),
            nombre: item.com_nombre as string
        }));
  }
}
